import { render, staticRenderFns } from "./SystemNotifications.vue?vue&type=template&id=53b0b398&scoped=true&"
import script from "./SystemNotifications.vue?vue&type=script&lang=js&"
export * from "./SystemNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b0b398",
  null
  
)

export default component.exports